import React from 'react';
import Modal from '../../common/Modal';
import FontIcon from '../../common/FontIcon';
import StarRating from '../super-admin/companies/coupons/manage/StarRating';
import { Coupon, CouponAssessment } from '../../types/generated.types';

const { REACT_APP_IMAGE_BASE_URL } = process.env;

interface CouponDetailsModalProps {
  coupon: Coupon | null;
  assessment: CouponAssessment | null | undefined;
  isOpen: boolean;
  onClose: () => void;
}

const CouponDetailsModal: React.FC<CouponDetailsModalProps> = ({ coupon, assessment, isOpen, onClose }) => {
  return (
    <Modal isOpen={isOpen} closeModal={onClose} className="coupon-details-modal">
      <div className="coupon-details-modal-content flex flex-col">
        {assessment?.rating !== undefined && assessment?.rating !== null && (
          <div className="coupon-details-modal-rating">
            <StarRating rating={assessment.rating} />
          </div>
        )}
        <div className="coupon-details-modal-coupon flex items-center justify-between mt">
          <div className="flex flex-col gap-2">
            <div className="coupon-details-modal-coupon-info flex flex-col">
              <h2>{coupon?.discount}</h2>
              <p className="smallTitle">{coupon?.smallTitle}</p>
            </div>
          </div>
          {coupon?.imageURL ?
            <img
              src={REACT_APP_IMAGE_BASE_URL + coupon?.imageURL}
              alt={coupon?.smallTitle || ''}
              height={55}
              width="auto"
              object-fit="contain"
            />
            :
            <div className='font-icon'>
              {FontIcon({ iconText: 'tag' })}
            </div>
          }
        </div>

        <div className="coupon-details-modal-assessment flex gap-2">
          {assessment?.motivation && (
            <p className="coupon-details-modal-motivation">{assessment.motivation}</p>
          )}
          {assessment?.expectedEffect && (
            <div className="assessment-column flex flex-col">
              <h4 className="uppercase">Förväntad effekt</h4>
              <p>{assessment.expectedEffect}</p>
            </div>
          )}
          {assessment?.profitability && (
            <div className="assessment-column flex flex-col">
              <h4 className="uppercase">Lönsamhet</h4>
              <p>{assessment.profitability}</p>
            </div>
          )}
          {assessment?.targetGroupAdaptation && (
            <div className="assessment-column flex flex-col">
              <h4 className="uppercase">Målgruppsanpassning</h4>
              <p>{assessment.targetGroupAdaptation}</p>
            </div>
          )}
        </div>
      </div>
    </Modal>
  );
};

export default CouponDetailsModal;

